module.exports = __webpack_public_path__ + "img/motorbikeFrontRight.eed17c02.svg";